import {
  fetchServiceAdditionalConnection,
  setFTTBServiceValuesAction,
  checkServiceAdditionalUserAgreement,
  changeServiceAdditionalPopupType,
  setServiceAdditionalConnectionEmail,
  switchServiceAdditionalPopup,
} from '../actions';
import { setItemValueById } from '../../utils/arraySetters';
import { SERVICE_CONNECTION_CODES } from '../../constants';
import { setServiceAdditionalPopupData } from '../actions/servicesActions';

const getFieldNameByCode = (code) => ({
  [SERVICE_CONNECTION_CODES.PROMISED]: 'promised',
  [SERVICE_CONNECTION_CODES.SUCCESED]: 'succesed',
  [SERVICE_CONNECTION_CODES.ERROR]: 'error',
  [SERVICE_CONNECTION_CODES.NO_MONEY]: 'noMoney',
  [SERVICE_CONNECTION_CODES.CONNECTING]: 'connecting',
}[code]);

const servicesPopupReducer = {
  [fetchServiceAdditionalConnection]: (state, { payload: { serviceId, data } }) => ({
    ...state,
    additionalPopup: {
      ...state.additionalPopup,
      serviceId,
      type: SERVICE_CONNECTION_CODES.CONNECTING,
      connecting: {
        ...state.additionalPopup.connecting,
        ...data,
      },
    },
  }),
  [switchServiceAdditionalPopup]: (state, { payload: isOpen }) => ({
    ...state,
    additionalPopup: {
      ...state.additionalPopup,
      isOpen,
    },
  }),
  [setServiceAdditionalConnectionEmail]: (state, { payload: email }) => ({
    ...state,
    additionalPopup: {
      ...state.additionalPopup,
      connecting: {
        ...state.additionalPopup.connecting,
        email,
      },
    },
  }),
  [checkServiceAdditionalUserAgreement]: (state, { payload: isChecked }) => ({
    ...state,
    additionalPopup: {
      ...state.additionalPopup,
      promised: {
        ...state.additionalPopup.promised,
        isChecked,
      },
    },
  }),
  [changeServiceAdditionalPopupType]: (state, { payload }) => ({
    ...state,
    additionalPopup: {
      ...state.additionalPopup,
      type: payload,
    },
  }),
  [setServiceAdditionalPopupData]: (state, { payload: { code, texts: data } }) => ({
    ...state,
    additionalPopup: {
      ...state.additionalPopup,
      type: code,
      [getFieldNameByCode(code)]: {
        ...state.additionalPopup.succesed,
        ...data,
        ...(code === SERVICE_CONNECTION_CODES.PROMISED ? { isChecked: false } : null),
      },
    },
  }),
};

export const servicesReducer = {
  ...servicesPopupReducer,
  [setFTTBServiceValuesAction]: (state, { payload: { serviceId, ...value } }) => ({
    ...state,
    additionalServices: setItemValueById(serviceId,
      {
        list: state.additionalServices,
        value,
      }),
  }),
};
